import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Entities, InsertActionData } from '../../data-rules-model';
import { DataRulesService } from '../../data-rules.service';
import { AutocompleteComponent } from '../../lib/autocomplete/autocomplete.component';
import { ProviderFactory } from '../../lib/provider-factory';
import { MetaDataService } from '../../meta-data.service';
import { IrreversibleActionWarningBlockComponent } from '../action-warning-block/irreversible-action-warning-block.component';

@Component({
  selector: 'app-action-insert-multiple',
  templateUrl: './insert-multiple-action.component.html',
  imports: [
    ReactiveFormsModule,
    AutocompleteComponent,
    IrreversibleActionWarningBlockComponent
  ],
  styleUrls: ['../action.component.scss']
})
export class InsertMultipleActionComponent implements OnInit {
  @Input() actionData: InsertActionData;
  @Input() actionForm: FormGroup;
  @Input() primaryEntity: Entities;
  toManyPlaceholderText: string;
  warningMessage = 'Using INSERT is irreversible and will not produce sample output. Are you sure you want to proceed?';
  entitySourceTypeControl: FormControl;
  entityDestinationTypeControl: FormControl;
  sourceIdControl: FormControl;

  private sourceIdPickerComponent: AutocompleteComponent;

  constructor(protected metaDataService: MetaDataService,
              private providerFactory: ProviderFactory,
              public dataRulesService: DataRulesService) {
  }

  @ViewChild('sourceId')
  set sourceId(v: AutocompleteComponent) {
    setTimeout(() => this.setSourceIdPickerComponent(v), 0);
  }

  get certificationRequirement(): string {
    if (this.primaryEntity === Entities.PLACEMENT)
      return `${this.primaryEntity}Certification`;
    else
      return `${this.primaryEntity}CertificationRequirement`;
  }

  ngOnInit(): void {
    this.createControls();
    this.subscribeToChanges();
  }

  createControls(): void {
    this.actionForm.removeControl('type');
    this.actionForm.removeControl('entitySourceType');
    this.actionForm.removeControl('entityDestinationType');
    this.actionForm.removeControl('sourceId');
    this.actionForm.removeControl('destinationType');

    this.entitySourceTypeControl = new FormControl(this.actionData.value.entitySourceType);
    this.entityDestinationTypeControl = new FormControl(this.actionData.value.entityDestinationType);
    this.sourceIdControl = new FormControl(this.actionData.value.sourceId, Validators.required);

    this.actionForm.addControl('type', new FormControl(this.actionData.type));
    this.actionForm.addControl('entitySourceType', this.entitySourceTypeControl);
    this.actionForm.addControl('entityDestinationType', this.entityDestinationTypeControl);
    this.actionForm.addControl('sourceId', this.sourceIdControl);
    this.actionForm.addControl('destinationType', new FormControl(this.actionData.destinationType));
  }

  subscribeToChanges(): void {
  }

  private setSourceIdPickerComponent(acComponent: AutocompleteComponent): void {
    this.sourceIdPickerComponent = acComponent;
    this.toManyPlaceholderText = 'Loading...';
    this.sourceIdControl.disable();
    this.providerFactory.getCertificationGroupsProvider(this.sourceIdControl.value).subscribe(provider => {
      this.sourceIdPickerComponent.setOptionsProvider(provider, this.sourceIdControl.value);
      this.toManyPlaceholderText = undefined;
      this.sourceIdControl.enable();
    });
  }
}
